import { render, staticRenderFns } from "./PerfilForm.vue?vue&type=template&id=2770b877&"
import script from "./PerfilForm.vue?vue&type=script&lang=js&"
export * from "./PerfilForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports